import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchSpecifications = (_, { payload }) => {
    return [
      ...payload,
    ]
  };

  const saveSpecification = (state, { payload }) => {
      return [...state, payload];
  }
  
  const updateSpecification = (state, {payload}) => {
    return state.map(item => {
      if(item.id === payload.id) {
        return payload;
      } else {
        return item;
      }
    })
  }

  const deleteSpecification = (state, {payload}) => {
    return state.filter(item => item.id !== payload);
  }

  const clearSpecifications = () => {
    return initialState;
  }
  const initialState = [];

  export default createReducer(initialState, {
    [TYPES.FETCH_SPECIFICATIONS_DONE]: fetchSpecifications,
    [TYPES.SPECIFICATION_SAVE_DONE] : saveSpecification,
    [TYPES.SPECIFICATION_UPDATE_DONE] : updateSpecification,
    [TYPES.SPECIFICATION_DELETE_DONE] : deleteSpecification,
    [TYPES.CLEAR_SPECIFICATIONS_DONE]: clearSpecifications
  });